import { createBrowserHistory } from 'history';
import { RouterStateParams } from '#shared/types/common';
import { APP_URL_PREFIX } from '../constants/routes';

export const history = createBrowserHistory<RouterStateParams>({ basename: APP_URL_PREFIX, getUserConfirmation() {} });
